import { Component, OnInit, ViewChild, Injector } from '@angular/core';
import {
  CommonFunctionService,
  UserMerchantData,
} from '../../../../services/Common/common-function.service';
import { Router } from '@angular/router';
const screenfull = require('screenfull');
import { TransactionService } from 'src/app/services/transaction/transaction.service';
// import { UserblockService } from '../../../../../../sidebar/userblock/userblock.service';
import { SettingsService } from '../../../../core/settings/settings.service';
import { MenuService } from '../../../../core/menu/menu.service';
import { RegisterUserService } from 'src/app/services/registerUser/register-user.service';
import { environment } from 'src/environments/environment';
const swal = require('sweetalert');
const _clone = (d) => JSON.parse(JSON.stringify(d));

@Component({
  selector: 'app-payout-header',
  templateUrl: './payout-header.component.html',
  styleUrls: ['./payout-header.component.scss'],
})
export class PayoutHeaderComponent implements OnInit {
  currency: any;
  PaygsetUphideshow: boolean = true;
  Activepayout = 0;
  payoutpermissionvalue = 0;
  content;
  LogoContent: any;
  merchantKeyId: any;
  payoutgideshow: boolean = false;
  prepaidcardvalue = 0;
  payoutvalue = 0;
  rows = [];
  resellerno: any;
  homeurl: any;
  isShown: boolean = false;
  navCollapsed = true; // for horizontal layout
  menuItems = []; // for horizontal layout
  submenu = true; // for horizontal layout
  reportmenu = true;
  settingsmenu = true;
  MerchantLogo: boolean = false;
  PaygLogo: boolean = false;
  profilemenu = true;
  image: boolean = false;
  paygimage: boolean = true;
  username: any;
  isNavSearchVisible: boolean;
  isLive: boolean = false;
  live: boolean = false;
  test: boolean = false;
  saveUsername: boolean = false;
  isMerchantGSThave: boolean = false;
  mode: any;
  logoimagepath: any;
  value;
  status: any;
  MerchantKeyId: any;
  getinfo: any;
  modeStatus: any;
  documentListRows = [];
  isPaymentOrdersAccess: boolean = false;
  paymentLedger: boolean = false;

  @ViewChild('fsbutton', { static: true }) fsbutton;
  // public userblockService: UserblockService,
  constructor(
    public menu: MenuService,
    private router: Router,
    private commonfunction: CommonFunctionService,
    public settings: SettingsService,
    public registerUserService: RegisterUserService,
    public injector: Injector,
    private transactionservice: TransactionService
  ) {
    // show only a few items on demo
    this.menuItems = menu.getMenu().slice(0, 4); // for horizontal layout
    this.username = this.commonfunction.getUserName();

    this.getinfo = localStorage.getItem('Merchantinfoes');
    if (
      this.getinfo == '' ||
      this.getinfo == undefined ||
      this.getinfo == null
    ) {
      this.getMerchantStatus();
      this.getinfo = 1;
      localStorage.setItem('Merchantinfoes', this.getinfo);
    } else {
      this.modeStatus = localStorage.getItem('Status');
      if (this.modeStatus == 21) {
        this.isLive = false;
        this.test = true;
      } else {
        this.isLive = true;
        this.live = true;
      }
    }
    //this.getMerchantStatus();
    this.MerchantKeyId =
      this.commonfunction.getUserMerchantData().MerchantKeyId;
    this.resellerno = this.commonfunction.getUserMerchantData().ResellerId;
    let imagepath = localStorage.getItem('logodetails');
    if (imagepath == '1') {
      this.logoimagepath = localStorage.getItem('logoimagepath');
      this.image = true;
      this.paygimage = false;
    } else {
      this.image = false;
      this.paygimage = true;
    }

    this.getBoardingKYCDataInfo();
    this.getUserPermissions();
    // this.prepaidcardoption();
    // var PayOuturl = this.router.url.includes('PayOut');
    // var prepaidcardturl = this.router.url.includes('prepaidcards');
    // if(PayOuturl==true)
    // {
    //   this.PayOutoption();
    // }
    // if(prepaidcardturl==true)
    // {
    //   this.prepaidcardoption();
    // }
  }

  ngOnInit() {
    localStorage.removeItem('MerchantLogo');
    let KeyId = this.commonfunction.getUserMerchantData().MerchantKeyId;
    // this.registerUserService.getMerchantLogoInfo(KeyId).subscribe((result) => {
    //   this.LogoContent = result;
    //   if (
    //     this.LogoContent.length != 0 &&
    //     this.LogoContent.length != undefined
    //   ) {
    //     if (
    //       result[0].Content != 'NULL' ||
    //       result[0].Content != '' ||
    //       result[0].Content != undefined
    //     ) {
    //       // if(result[0] .Length == "null" )
    //       this.content = result[0].Content;
    //       localStorage.setItem('MerchantLogo', this.content);
    //       this.PaygLogo = false;
    //       this.MerchantLogo = true;
    //     }
    //   } else {
    //     this.PaygLogo = true;
    //     this.MerchantLogo = false;
    //   }
    // });
    this.isNavSearchVisible = false;
    this.homeurl = environment.HomeUrl;
    var ua = window.navigator.userAgent;
    if (ua.indexOf('MSIE ') > 0 || !!ua.match(/Trident.*rv\:11\./)) {
      // Not supported under IE
      this.fsbutton.nativeElement.style.display = 'none';
    }

    // Switch fullscreen icon indicator
    const el = this.fsbutton.nativeElement.firstElementChild;
    screenfull.on('change', () => {
      if (el)
        el.className = screenfull.isFullscreen
          ? 'fa fa-compress'
          : 'fa fa-expand';
    });

    this.router = this.injector.get(Router);

    // Autoclose navbar on mobile when route change
    this.router.events.subscribe((val) => {
      // scroll view to top
      window.scrollTo(0, 0);
      // close collapse menu
      this.navCollapsed = true;
    });
  }

  prepaidcardoption() {
    this.registerUserService
      .getMerchantServicesAndFees(this.MerchantKeyId, this.resellerno)
      .subscribe((result) => {
        if (result != null) {
          this.rows = _clone(result);

          this.rows.forEach((element) => {
            if (element.ServiceCode == 'PayOut' && element.Status == 1) {
              this.payoutgideshow = true;
              //  this.PayOutoption();
            }

            if (element.ServiceCode == 'PayGSetUp' && element.Status == 1) {
              this.PaygsetUphideshow = true;
            }

            if (element.ServiceCode == 'PayGSetUp' && element.Status == 0) {
              this.PaygsetUphideshow = false;
            }

            if (element.ServiceCode == 'PrepaidCard') {
              if (element.ServiceCode == 'PrepaidCard' && element.Status == 1) {
              } else {
                this.router.navigate(['/home']);
              }
            }
          });
        }
      });
  }
  get headerTitle() {
    if (this.router.url.includes('/PayOut/ViewPayOutContact;Id')) {
      return 'View PayOut Contacts';
    } else if (this.router.url.includes('/PayOut/ViewBeneficiaries;Id')) {
      return 'View Beneficiary';
    } else if (this.router.url.includes('/PayOut/EditPayOutContact;Id')) {
      return 'Edit PayOut Contact';
    } else if (this.router.url.includes('/PayOut/DeletePayoutContacts;Id')) {
      return 'Delete Payout Contacts ';
    } else if (this.router.url.includes('/PayOut/AddBeneficiaries;Id')) {
      return 'Add PayOut Beneficiary';
    } else if (
      this.router.url.includes('/PayOut/ViewBeneficiaries;PayoutCustomerkeyId')
    ) {
      return 'PayOut Add transaction detail';
    } else if (this.router.url.includes('/PayOut/ViewPayOutTransactions;Id')) {
      return 'View PayOut Transactions';
    } else if (this.router.url.includes('NewPayOutContact')) {
      return 'New PayOut Contact';
    } else if (this.router.url.includes('PayOut/ManagePayOutContact')) {
      return 'PayOut Contact';
    } else if (this.router.url.includes('PayOut/BeneficiaryList')) {
      return 'PayOut Beneficiary';
    } else if (this.router.url.includes('PayOut/PayOutTransactions')) {
      return 'PayOut Transactions';
    } else if (this.router.url.includes('PayOut/PayOutBatches')) {
      return 'PayOut Settlements';
    } else if (this.router.url.includes('PayOut/ManagePayOutBulkUploadFiles')) {
      return 'PayOut Bulk File Uploads';
    } else if (this.router.url.includes('/PayOut/PayoutAccountdetails')) {
      return 'PayOut Security';
    } else if (
      this.router.url.includes(' /PayOut/PayoutSecurityTransactions')
    ) {
      return 'PayOut Security Transactions';
    } else {
      return 'Payout Dashboard';
    }
  }
  PayOutoption() {
    this.registerUserService
      .getMerchantServicesAndFees(this.MerchantKeyId, this.resellerno)
      .subscribe((result) => {
        if (result != null) {
          this.rows = _clone(result);

          this.rows.forEach((element) => {
            if (element.ServiceCode == 'PayOut' && element.Status == 1) {
              this.payoutvalue = 1;
            }
          });
          if (this.payoutvalue == 1) {
          } else {
            this.router.navigate(['/home']);
          }
        }
      });
  }

  getBoardingKYCDataInfo() {
    if (environment.disableUserKycAndUserProfileApiCall == false) {
      this.registerUserService
        .getBoardingKycDatas(this.MerchantKeyId)
        .subscribe((result) => {
          console.log('Boarding KYC Datas result', result);
          if (result != null) {
            this.documentListRows = _clone(result);
            var count = 0;
            console.log('this.documentListRows', this.documentListRows);
            this.documentListRows.forEach((element) => {
              if (element.FileType == 14 && element.Status == 1) {
                count++;
              }
            });
            if (count >= 1) {
              this.isMerchantGSThave = true;
            } else {
              this.isMerchantGSThave = false;
            }
          }
        });
    }
  }

  getMerchantStatus() {
    let merchantKeyId = this.commonfunction.getUserMerchantData().MerchantKeyId;
    this.registerUserService
      .getMerchantDetails(merchantKeyId)
      .subscribe((result) => {
        if (environment.clientsidelogflag == 0) {
          console.log('View result - ', result);
        }
        this.status = result.Status;
        localStorage.setItem('Status', this.status);
        if (result.Status == 21) {
          this.isLive = false;
          this.test = true;
          // this.isTest = true;
        } else {
          this.isLive = true;
          this.live = true;
          // this.isTest = false;
        }
      });
  }

  test1() {
    this.mode = 0;

    if (this.mode == 0) {
      //this.status ==21
      // swal("Alert", "Please complete the Onboarding Process To Access Live Mode", "success").then(function(){
      //     location.reload();
      //     }
      //  );

      this.router.navigate([
        '/registration/InprogressPage',
        { merchantKeyId: this.MerchantKeyId, status: 21 },
      ]);
    }
    // if (this.mode == 1 && this.status !=21) {

    //     swal("Alert", "Dear Merchant, You are in Test Mode cannot access Live data", "success");
    //     // .then(function(){
    //     //     location.reload();
    //     //     }
    //     //  );
    // }
  }

  openConfirmationDialog() {
    swal({
      style: 'font-size:12px;',
      title:
        'To Access the Live Mode, Please complete the registration. Would you like to proceed to Registration..?',
      icon: 'warning',
      buttons: {
        cancel: {
          text: 'Cancel!',
          value: null,
          visible: true,
          className: '',
          closeModal: true,
        },
        confirm: {
          text: 'Yes!',
          value: true,
          visible: true,
          className: 'bg-danger',
          closeModal: true,
        },
      },
    }).then((isConfirm) => {
      if (isConfirm) {
        this.test1();
      } else {
        location.reload();
      }
    });
  }

  // toggleUserBlock(event) {
  //     event.preventDefault();
  //     this.userblockService.toggleVisibility();
  // }
  toggleUserBlock(event) {
    // event.preventDefault();
    // this.userblockService.toggleVisibility();
  }

  openNavSearch(event) {
    event.preventDefault();
    event.stopPropagation();
    this.setNavSearchVisible(true);
  }

  setNavSearchVisible(stat: boolean) {
    // console.log(stat);
    this.isNavSearchVisible = stat;
  }

  getNavSearchVisible() {
    return this.isNavSearchVisible;
  }

  toggleOffsidebar() {
    this.settings.toggleLayoutSetting('offsidebarOpen');
  }

  toggleCollapsedSideabar() {
    this.settings.toggleLayoutSetting('isCollapsed');
  }

  isCollapsedText() {
    return this.settings.getLayoutSetting('isCollapsedText');
  }

  toggleFullScreen(event) {
    if (screenfull.enabled) {
      screenfull.toggle();
    }
  }
  getLive(value: boolean) {
    this.saveUsername = value;
    // alert('live');
    alert(value);
    console.log('event', value);
  }

  getUserPermissions() {
    const merchantdata: UserMerchantData =
      this.commonfunction.getUserMerchantData();
    //let appName='Merchant';
    this.transactionservice
      .GetuserRoleBasedPermissions(merchantdata.UserId, 'Merchant')
      .subscribe((result) => {
        if (result != null) {
          for (var i in result) {
            if (result[i].UserPermission == 'PaymentOrders') {
              var type = result[i].Type;
              if (type == 'R' || type == 'RW' || type == 'RWD') {
                this.isPaymentOrdersAccess = true;
              } else {
                this.isPaymentOrdersAccess = false;
              }
              break;
            }
            if (result[i].UserPermission == 'PaymentLedger') {
              var type = result[i].Type;
              if (type == 'R' || type == 'RW' || type == 'RWD') {
                this.paymentLedger = true;
              } else {
                this.paymentLedger = false;
              }
              break;
            }
          }
        }
      });
  }
  clear() {
    localStorage.removeItem('SettingDetails');
  }
}
